var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isConsumerCountryCodeValid } from "./ConsumerInfoValidator";
import { CONSUMER_FIRST_NAME_LENGTH, CONSUMER_LAST_NAME_LENGTH, getConsumerValidationProfile, } from "./ConsumerValidationProfiles";
var isConsumerInfoFormError = function (error) {
    return ["firstName", "lastName", "emailAddress", "mobileNumber", "countryCode"].indexOf(error.field) >= 0 &&
        ["REQUIRED", "INVALID_FORMAT", "INVALID_LENGTH"].indexOf(error.code) >= 0;
};
export var createConsumerInfoFormConfig = function (billingAddressCountryCode, selectedCardBrand) {
    var profile = selectedCardBrand
        ? getConsumerValidationProfile(selectedCardBrand)
        : {
            firstNameLength: CONSUMER_FIRST_NAME_LENGTH,
            lastNameLength: CONSUMER_LAST_NAME_LENGTH,
        };
    return {
        firstName: {
            maxLength: profile.firstNameLength.max,
        },
        lastName: {
            minLength: profile.lastNameLength.min,
            maxLength: profile.lastNameLength.max,
        },
        countryCode: {
            required: !isConsumerCountryCodeValid(billingAddressCountryCode),
        },
    };
};
export var copySrciConsumer = function (consumer) {
    return consumer
        ? __assign(__assign(__assign({}, consumer), (consumer.mobileNumber ? { mobileNumber: __assign({}, consumer.mobileNumber) } : {})), (consumer.consumerIdentity ? { consumerIdentity: __assign({}, consumer.consumerIdentity) } : {})) : undefined;
};
export var toConsumerInfoFormErrors = function (errors) {
    return errors.filter(isConsumerInfoFormError).map(function (error) { return ({
        field: error.field,
        code: error.code,
        minLength: error.minLength,
        maxLength: error.maxLength,
    }); });
};
export var hasNonFieldConsumerInfoErrors = function (errors) {
    return errors.some(function (error) { return !isConsumerInfoFormError(error); });
};
export var getChangedConsumerInfoFields = function (previousValue, candidate) {
    var fields = ["firstName", "lastName", "emailAddress", "countryCode"];
    var changedFields = fields.filter(function (field) { return previousValue[field] !== candidate[field]; });
    if (previousValue.mobileNumber.countryCode !== candidate.mobileNumber.countryCode ||
        previousValue.mobileNumber.phoneNumber !== candidate.mobileNumber.phoneNumber) {
        changedFields.push("mobileNumber");
    }
    return changedFields;
};
export var createCardHolderInfo = function (billingAddress, consumer) {
    var _a;
    var billingName = (_a = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.name) === null || _a === void 0 ? void 0 : _a.trim();
    var consumerName = "".concat(consumer.firstName, " ").concat(consumer.lastName).trim();
    return __assign({ cardholderFullName: billingName || consumerName }, (billingAddress ? { billingAddress: billingAddress } : {}));
};
